export const openMailTo = (mailTo: string) => {
    if (mailTo === "") return;
    let call = document.createElement("a");
    call.setAttribute("target", "_blank");
    call.href = `mailto:${mailTo}`;
    call.click();
    call.remove();
  };
  